import React from "react";

export default class Form extends React.Component {
                   constructor(props) {
                       super(props);
                       this.state = {
                           selectedOption: "rechteckig",
                       };

                       this.handleOptionChange = this.handleOptionChange.bind(this);
                   }
                  

                   handleOptionChange(changeEvent) {
                       this.setState({
                           selectedOption: changeEvent.target.value,
                       });
                       this.props.chooseAusschnitt(changeEvent.target.value);
                   };

                   render() {
                       return (
                           <div>
                               {/* <p>
                                   Wählen Sie eine der folgenden Formen aus:
                               </p> */}

                               <form>
                                   <div className="mk-form-container">
                                       <div className="mk-form-item-1">
                                           <input
                                               type="radio"
                                               name="react-tips"
                                               value="rechteckig"
                                               checked={
                                                   this.state.selectedOption ===
                                                   "rechteckig"
                                               }
                                               onChange={
                                                   this.handleOptionChange
                                               }
                                           />
                                       </div>
                                       <div className="mk-form-item-2">
                                           <p className="mk-h1">rechteckig</p>
                                           <p className="mk-p-klein">
                                               gemäß des Seitenverhältnis der
                                               Datei
                                           </p>
                                       </div>
                                       <div className="mk-form-item-3 mk-form-img-1"></div>
                                   </div>

                                   <div className="mk-form-container">
                                       <div className="mk-form-item-1">
                                           <input
                                               type="radio"
                                               name="react-tips"
                                               value="aussenform"
                                               checked={
                                                   this.state.selectedOption ===
                                                   "aussenform"
                                               }
                                               onChange={
                                                   this.handleOptionChange
                                               }
                                           />
                                       </div>
                                       <div className="mk-form-item-2">
                                           <p className="mk-h1">
                                               außenform 
                                               {/* (+ 8€) */}
                                           </p>
                                           <p className="mk-p-klein">
                                               Aufkleber wird anhand der
                                               Außenform ausgeschnitten
                                           </p>
                                       </div>
                                       <div className="mk-form-item-3 mk-form-img-2"></div>
                                   </div>

                                   <div className="mk-form-container">
                                       <div className="mk-form-item-1">
                                           <input
                                               type="radio"
                                               name="react-tips"
                                               value="kontur"
                                               checked={
                                                   this.state.selectedOption ===
                                                   "kontur"
                                               }
                                               onChange={
                                                   this.handleOptionChange
                                               }
                                           />
                                       </div>
                                       <div className="mk-form-item-2">
                                           <p className="mk-h1">
                                               konturgeschnitten 
                                               {/* (+ 12€) */}
                                           </p>
                                           <p className="mk-p-klein">
                                               freistehender Aufkleber ohne
                                               Hintergrund
                                           </p>
                                       </div>
                                       <div className="mk-form-item-3 mk-form-img-3"></div>
                                   </div>
                               </form>
                           </div>
                       );
                   }
               }
